(function (window) {
  var strings = BatchGeoStrings.getStringsForComponent(
    "BatchGeoCalculateRoute",
  );

  function getLatLngFromMarker(marker) {
    var lng = marker.Lon;
    var lat = marker.Lat;
    return new google.maps.LatLng(lat, lng);
  }

  /**
   * buildRouteHtml takes a calculated route and displays text directions underneath the map div
   *
   * @param {Object} route googles generated route object
   *
   * @returns {jQuery} a jQuery element
   */
  function buildRouteHtml(route) {
    return $("<div />", {
      class: "directions",
      // the route is split up into legs; each leg provides the directions from one point to another
      html: route.legs.map(function (leg) {
        return $("<h3 />", {
          class: "waypoint",
          html: ["From " + leg.start_address]
            //each leg has a steps array; each step provides distance and instructions
            .concat(
              leg.steps.map(function (step) {
                return $("<div />", {
                  html: [
                    $("<p />", {
                      class: "instructions",
                      html: step.instructions,
                    }),
                    $("<p />", {
                      class: "distance",
                      html: "after " + step.distance.text + " ",
                    }),
                  ],
                });
              }),
            ),
        });
      }),
    });
  }

  function getLatLngFromString(stringArray, callback, resultsArray) {
    resultsArray = resultsArray || {};
    if (stringArray.length === 0) {
      callback(resultsArray);
      return;
    }
    var addressTitle = Object.keys(stringArray[0]);

    //if the location is already geocoded
    if (typeof stringArray[0][addressTitle] !== "string") {
      resultsArray[addressTitle] = stringArray[0][addressTitle];
      stringArray.shift();
      getLatLngFromString(stringArray, callback, resultsArray);
      return;
    }

    var geocoder = new google.maps.Geocoder();
    geocoder.geocode(
      { address: stringArray[0][addressTitle] },
      function (results) {
        var position = {
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng(),
        };
        stringArray.shift();
        resultsArray[addressTitle] = position;
        getLatLngFromString(stringArray, callback, resultsArray);
      },
    );
  }

  /**
   * BatchGeoCalculateRoute is a component that leverages Googles directionsService
   * and directionsRenderer in order to calculate and display a route.
   *
   * @param {Object} settings Hash of the settings for the calculate route setup
   * @param {Object} settings.directionsRenderer an instance of directionsRenderer initialized in parent component
   * @param {Object} settings.directionsService an instance of directionsService initialized in parent component
   *
   * @constructor
   */
  var BatchGeoCalculateRoute = function (opts) {
    this.settings = $.extend(
      true,
      {
        directionsRenderer: null,
        directionsService: null,
      },
      opts,
    );
  };

  /**
   * buildValidRoute takes an origin and destination and sets up a route object in state. Then we grab
   * coordinates from each of the selected data rows, then add them to state. After that, we just call
   * display route.
   *
   * @param {string|LatLng|google.maps.Place} origin the starting point in the route - if it is not
   * provided it will default to the user's current location or the first marker in the data selection
   * @param {string|LatLng|google.maps.Place} destination the ending point in the route if it is not
   * provided it will default to the first marker in the data selection
   *
   * @returns {undefined}
   */
  BatchGeoCalculateRoute.prototype.buildValidRoute = function () {
    var self = this;
    var markers = window.batchGeoGoogleMapsMarker.getMarkersObjArray();
    var selectedRows =
      window.batchGeoTableMap.batchGeoTable.RowSelect.getSelectedRows();
    var selectedMarkers = selectedRows.map(function (selectedRow) {
      return markers[selectedRow.id];
    });
    var isGeocodingEnabled = window.geocodingEnabled;
    var route =
      BatchGeoStore.getState().BatchGeoOptimalRouteToolbar.optimalRoute;
    var origin = route.origin;
    var destination = route.destination;
    if (!origin) {
      var userLocation = BatchGeoStore.getState().UserLocation;
      var userCoordinates = new google.maps.LatLng(
        userLocation.latitude,
        userLocation.longitude,
      );
      origin = isGeocodingEnabled
        ? userCoordinates
        : getLatLngFromMarker(selectedMarkers[0]);
    }
    if (!destination) {
      // User starting location
      // Fall back to first selected marker
      destination = origin ? origin : getLatLngFromMarker(selectedMarkers[0]);
    }
    if (typeof destination === "function") {
      // if set start location isn't in the marker data and destination is set to
      // "End at Starting Location", destination is a function that returns the
      // starting location string
      destination = destination();
    }

    getLatLngFromString(
      [{ destination: destination }, { origin: origin }],
      function (geocodedResults) {
        BatchGeoStore.dispatch({
          type: "OPTIMAL_ROUTE_TOOLBAR_SET_ORIGIN",
          position: new google.maps.LatLng(geocodedResults.origin),
        });
        BatchGeoStore.dispatch({
          type: "OPTIMAL_ROUTE_TOOLBAR_SET_DESTINATION",
          position: new google.maps.LatLng(geocodedResults.destination),
        });

        selectedRows.forEach(function (selectedRow) {
          //loop through selected rows ID's and add the marker data to the waypoints array
          var marker = markers[selectedRow.id];
          BatchGeoStore.dispatch({
            type: "OPTIMAL_ROUTE_TOOLBAR_ADD_WAYPOINT",
            waypoint: {
              location: getLatLngFromMarker(marker),
              //this is a required property to send to google's directionsService
              //it indicates that the waypoint is a stop on the route, which has
              //the effect of splitting the route into two routes.
              stopover: true,
            },
          });
        });

        self.displayRoute();
      },
    );
  };

  /**
   * resetRoute dispatches the `OPTIMAL_ROUTE_RESET_ROUTE` event,
   * removes the route polyline, and clears the directions text below the map
   */
  BatchGeoCalculateRoute.prototype.resetRoute = function () {
    BatchGeoStore.dispatch({
      type: "OPTIMAL_ROUTE_RESET_ROUTE",
    });
    this.settings.directionsRenderer.setMap(null);
    $(".directions").empty();
  };

  /**
   * displayRoute takes a route object (it has origin, destion, and waypoint addresses) and
   * passes it to googles directionsService in order to calculate an optimal route and
   * then display it on the map.
   *
   */
  BatchGeoCalculateRoute.prototype.displayRoute = function () {
    var directionsRenderer = this.settings.directionsRenderer;
    var directionsService = this.settings.directionsService;
    var route =
      BatchGeoStore.getState().BatchGeoOptimalRouteToolbar.optimalRoute;
    directionsService.route(
      {
        origin: route.origin,
        destination: route.destination,
        waypoints: route.waypoints,
        optimizeWaypoints: true,
        travelMode: "DRIVING",
      },
      function (response, status) {
        if (status === "OK") {
          var routes = response.routes[0];

          // persist the legs for url building later
          // can also use waypoint_order but buildRouteHtml
          // uses the routes legs and we want to be consistent
          BatchGeoStore.dispatch({
            type: "OPTIMAL_ROUTE_TOOLBAR_SET_LEGS",
            legs: routes.legs,
          });

          //create div underneath the map with directions for the route
          $("#page").prepend(buildRouteHtml(routes));

          window.batchGeoTableMap.updateSelectedOrder(routes.waypoint_order);

          //directions renderer's setDirections method displays the calculated route on the map
          directionsRenderer.setDirections(response);
          $.colorbox.close();

          if (BatchGeoDevices.is("mobile")) {
            BatchGeoStore.dispatch([
              {
                type: "FEATURE_DISABLE",
                feature: "shouldRenderTable",
              },
              {
                type: "TABLE_MAP_VISIBILITY",
                visibility: false,
              },
            ]);
          }

          //only mark the route as complete if status is ok
          BatchGeoStore.dispatch({
            type: "OPTIMAL_ROUTE_TOOLBAR_ROUTE_COMPLETE",
          });
        } else {
          var $errorMessage = $("<div />", {
            html: $("<h3 />", {
              text: strings.get("ERROR_CANNOT_CALCULATE_ROUTE"),
            }),
          });
          $.colorbox.remove();
          BatchGeo.customAlert($errorMessage);
        }
      },
    );
  };

  window.BatchGeoCalculateRoute = BatchGeoCalculateRoute;
})(window);
